import { authHttp } from '../http'
import * as routes from '../../routes/deliveries.routes'
import { downloadErrorHandler, errorHandler } from '../../../util/error.service'

export async function getXmlImportLogsByTp(tp_id, pInicial, pFinal) {
  try {
    const { data } = await authHttp().get(routes.urlXmlImportLogsByTp(tp_id, pInicial, pFinal))
    return data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function downloadXmlImportLogByTp(tp_id, log_id) {
  try {
    const { data } = await authHttp().get(routes.urlXmlImportLogFileByTp(tp_id, log_id), {
      responseType: 'blob',
    })
    return data
  } catch (error) {
    throw await downloadErrorHandler(error)
  }
}
